export default "__VITE_ASSET__NOOtpTp___"